const User = {

    getUser() {
        try {
            return JSON.parse(localStorage.getItem('user'));
        } catch (e) {
            return null;
        }
    },

    setUser(user) {
        window.localStorage.user = JSON.stringify(user);
    },

    isGuest() {
        return this.getUser() === null;
    },

    requireUser() {
        let user = this.getUser();
        if (user === null) {
            this.logout();
        }

        return user;
    },

    logout() {
        window.localStorage.user = null;
        window.location.reload()
    },

    login(user) {
        this.setUser(user);
        window.location.href = '/'
    },

    setUserData(name, data) {
        let user = this.requireUser()
        user[name] = data;
        this.setUser(user);
    },

    enabledModules() {
        return this.requireUser().enabledModules;
    },
};

export default User


// WEBPACK FOOTER //
// ./src/helpers/user.js